import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from '../../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import {
    EnterValueInput,
    EnterValueResponse,
} from '../../../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import { EnterValueDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import { KieneBackendApiService } from '../../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { ConfirmDeleteDialogComponent } from '../../../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { AbgabebelegPosition } from '../../../../../../projects/kiene-core/src/lib/components/abgabebelege/classes/abgabebeleg-position';
import {
    Abgabebeleg,
    AbgabebelegStatus,
} from '../../../../../../projects/kiene-core/src/lib/components/abgabebelege/classes/abgabebeleg';

@Component({
    selector: 'kiene-position-details-dialog',
    templateUrl: './position-details-dialog.component.html',
    styleUrls: ['./position-details-dialog.component.scss'],
})
export class PositionDetailsDialogComponent implements OnInit {
    protected readonly KieneUtils = KieneUtils;

    currentUserIsAdmin = false;
    isLoading = false;
    p: AbgabebelegPosition;
    abgabebeleg: Abgabebeleg;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PositionDetailsDialogComponent>,
        private localStorageService: LocalStorageService,
        private dialog: MatDialog,
        private api: KieneBackendApiService,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) public apiBaseUrl: string,
    ) {
        this.p = this.data?.p;
        this.abgabebeleg = this.data?.abgabebeleg;
        this.currentUserIsAdmin = this.localStorageService.getCurrentUser().admin > 0;
    }

    ngOnInit(): void {}

    chargenText(p: AbgabebelegPosition) {
        let txt = '';
        for (const c of p?.chargen) {
            txt += c.chargenmenge + 'x ' + c.charge + ' MHD: ' + c.mhd + '; ';
        }
        return txt;
    }

    preisEditierbar(): boolean {
        if (
            this.abgabebeleg?.status_id === AbgabebelegStatus.ERSTELLT ||
            this.abgabebeleg?.status_id === AbgabebelegStatus.WIRD_KORRIGIERT
        ) {
            return this.localStorageService.hasPermission(3058) && !this.abgabebeleg.rechnung_ids;
        } else {
            return false;
        }
    }

    hasPermission(id: number) {
        return this.localStorageService.hasPermission(id);
    }

    einzelpreisEditieren() {
        if (this.hasPermission(1229) && this.preisEditierbar()) {
            const input = new EnterValueInput();
            input.title = 'Einzelpreis ändern';
            input.text = 'Bitte geben Sie den Einzelpreis für diese Position ein.';
            input.okButton = 'Speichern';
            input.buttonColor = 'accent';
            input.addInputValue('Einzelpreis', 'decimal', this.p.einzelpreis);

            const dialogRef = this.dialog.open(EnterValueDialogComponent, { data: input });

            dialogRef.afterClosed().subscribe((result: EnterValueResponse) => {
                if (result.result) {
                    this.p.einzelpreis = result.getValue(0);
                    this.api.updateGeneric(this.apiBaseUrl + 'abgabebeleg/update_einzelpreis.php', this.p).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Der Einzelpreis wurde erfolgreich gespeichert!');
                            this.dialogRef.close(true);
                        },
                        error: err => {
                            this.messageService.errorMessage('Der Einzelpreis konnte nicht gespeichert werden!', err);
                        },
                    });
                }
            });
        }
    }

    removePosition() {
        this.isLoading = true;
        this.dialog
            .open(ConfirmDeleteDialogComponent)
            .afterClosed()
            .subscribe({
                next: result => {
                    this.isLoading = false;
                    if (result) {
                        const removed: { index: number; position: AbgabebelegPosition }[] = [];
                        if (KieneUtils.isApiOne(this.p.stueckliste)) {
                            removed.push(...this.removeStuecklistenpositionen(this.p));
                        }
                        const index = this.abgabebeleg.positionen.indexOf(this.p);
                        if (index >= 0) {
                            removed.push({ index, position: this.abgabebeleg.positionen[index] });
                            this.abgabebeleg.positionen.splice(index, 1);
                        }
                        this.save(removed);
                    }
                },
            });
    }

    /** @return entfernte Stücklisten-Positionen inkl. Index (für Rollback bei Speichern-Fehler) */
    removeStuecklistenpositionen(pos: AbgabebelegPosition): { index: number; position: AbgabebelegPosition }[] {
        const removed: { index: number; position: AbgabebelegPosition }[] = [];
        for (let i = this.abgabebeleg.positionen.length - 1; i >= 0; i--) {
            const p = this.abgabebeleg.positionen[i];
            if (p.aus_stueckliste === pos.aa_id) {
                removed.push({ index: i, position: p });
                this.abgabebeleg.positionen.splice(i, 1);
            }
        }
        return removed;
    }

    private save(removedForRollback: { index: number; position: AbgabebelegPosition }[] = []) {
        this.isLoading = true;
        this.api.updateGeneric(this.apiBaseUrl + 'abgabebeleg/update.php', this.abgabebeleg).subscribe({
            next: () => {
                this.isLoading = false;
                this.dialogRef.close(true);
            },
            error: err => {
                // Speichern fehlgeschlagen (z.B. Charge einer anderen Position) → UI-Zustand zurücksetzen
                for (const item of [...removedForRollback].sort((a, b) => a.index - b.index)) {
                    this.abgabebeleg.positionen.splice(item.index, 0, item.position);
                }
                this.isLoading = false;
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    showPriceActionButton() {
        if (
            this.abgabebeleg?.status_id === AbgabebelegStatus.ERSTELLT ||
            this.abgabebeleg?.status_id === AbgabebelegStatus.WIRD_KORRIGIERT
        ) {
            return 'edit';
        }
        return '';
    }
}
